import {
    string,
    shape,
    number,
  } from "prop-types";

const HEAD_MAPS_LIVEREAD = {
    media_type: "",
    mention_name: "Title",
    adsTypeName: "Ad Type",
    creative_duration: "Duration",
    station_name: "Station",
    stationLocalTime: "Station Local Time",
    visits: "Ad Visits",
    new_users: "New Ad Users",
    status_reassign: "Reassigned"
};

const KEYS = [
    "mention_name",
    "adsTypeName",
    "creative_duration",
    "station_name",
    "airtime",
    "stationLocalTime",
    "visits",
    "new_users",
    "status",
    "status_reassign",
    "media_type",
    "media_id",
    "ads_type_id",
    "mention_id",
    "collected_date",
    "airtime",
    "stationTimezone"
];

const HEADER_SHOW_ALL_ADS = [
    "Title",
    "Ad Type",
    "Duration",
    "Station",
    "User Local Time",
    "Station Local Time",
    "Ad Visits",
    "New Ad Users",
    "Exclude",
    "Reassigned"
];

export default {
    HEAD_MAPS_LIVEREAD,
    KEYS,
    HEADER_SHOW_ALL_ADS,
};

export const detailUrlPropsType = shape({
    urlApi: shape({
      advertiser: string,
      baseUrl: string,
      checkToken: string,
      folder: string,
      graphql: string,
      listFolder: string,
      searchBar: string,
      searchBarAggregate: string,
      updateToken: string
    }),
    adType: string,
    advertiserId: number,
    startDate: string,
    endDate: string
  })
